module.exports = __webpack_public_path__ + "img/b_15.3bc8ae41.jpg";